import {Module} from "wrapper6";
import drops from "drops";
var $ = window.jQuery;

export default class BranchSearchModule extends Module {

    boot(app) {
        this.input = $("select#branch-filter").get(0);
        this.host = ajaxurl;
        this.depth = [];

        if (this.input == null) {
            return false;
        }
    }

    ready() {
        this.createField();
        this.setupNavigation();

        // Add name to the queryInput to pass the value forward
        //this.field.elements.queryInput.name = "industry_search";

        // Add a new hidden field containing the current parent category
        this.parentField = $('<input type="hidden" name="" />');
        $(this.field.elements.input).after(this.parentField);
    }

    createField() {
        var _ = this;

        // Create field
        this.field = drops.create("select", this.input, {

            getArrow() {
                return '<div class="arrow_down">' +
                    '<div class="line_one"></div>' +
                    '<div class="line_two"></div>' +
                    '</div>';
            },

            optionTrigger: ".drops-option-trigger",
            getOption(field, data) {
                var children = parseInt(data.children),
                    html;

                if (data.is_parent) {
                    html = `<div class="drops-option-trigger">${data.label}</div>`;
                }
                else if (
                    (children > 0) ||
                    ((data.value.length === 0) &&
                    ((_.depth.length > 0) || (field.elements.queryInput.value.length > 0)))
                ) {
                    html = `<div class="drops-option-trigger drops-option-deeper">${data.label}</div>` +
                        `<div class="drops-option-expand">` +
                        `<div class="arrow_right">` +
                        `<div class="line_one"></div>` +
                        `<div class="line_two"></div>` +
                        `</div>` +
                        `</div>`;
                }
                else {
                    html = `<div class="drops-option-trigger">${data.label}</div>`;
                }

                return html;
            },

            queryPlaceholder: "Skriv for at søge...",
            query(field, options, queryString) {
                if ((queryString.length > 0) && (queryString.length < 2) && !parseInt(queryString)) {
                    return;
                }

                // Hide current options
                $(options).not("[data-value='']").hide();

                // Do query
                $('.loader_no_results').remove();
                $('.loader_small').addClass('is-loading');

                // Clear depth
                _.depth = [];

                (queryString.length > 0 ?
                    _.query(queryString) :
                    _.collapse()).then(function (jsonResponse) {

                    // Set new options
                    field.setOptions(field.options.buildOptions(field, jsonResponse));
                });
            },

            buildOptions(field, responseJson) {
                $('.loader_small').removeClass('is-loading');

                // Compute options
                var response = JSON.parse(responseJson),
                    options = [],
                    length = response.hits.hits.length,
                    entry,
                    currentValue = field.get();

                if (length === 0) {
                    $('.drops-body .drops-query').append('<span class="loader_no_results">Ingen resultater fundet</span>');
                }

                for (var i = 0; i < length; i++) {
                    entry = response.hits.hits[i];

                    options.push({
                        value: entry._source.code,
                        label: entry._source.title,
                        selected: entry._source.code === currentValue,
                        children: entry._source.children,
                        parent: entry._source.parent
                    });
                }

                return options;
            }

        });
    }

    setupNavigation() {
        var _ = this;

        // Extend the field so it works with depth selector
        $(this.field.elements.options).on("click", ".drops-option-expand", function (e) {
            e.preventDefault();
            var trigger = $(this),
                option = trigger.parents(".drops-option"),
                data = _.field.getOptionData(option.get(0).dataset.value);

            _.expand(data).then((jsonResponse) => {
                var options = _.field.options.buildOptions(_.field, jsonResponse);

                // Add parent group
                if (data.value.length > 0) {
                    options.unshift(data);
                }

                _.field.setOptions(options);
            });
        });

        /*$(this.field.elements.options).on("click", ".drops-option-collapse", function (e) {
         e.preventDefault();

         _.collapse().then((jsonResponse) => {
         var options = _.field.options.buildOptions(_.field, jsonResponse),
         currentParent = _.currentParent;

         if (currentParent) {
         options.unshift(currentParent);
         }

         _.field.setOptions(options);
         });
         });*/

        $('.drops-query input[type="text"]').keypress(function(e){
            if (e.which == 13) {
                e.preventDefault();
            }
        });
    }

    query(queryString) {
        return $.post(this.host, {
            action: 'search_industry',
            queryString: queryString,
        });
    }

    queryByParent(parent) {
        return $.post(this.host, {
            action: 'find_industry_subgroups',
            parent_code: parent,
        });
    }

    expand(groupData) {
        if (groupData.value.length > 0) {
            this.parentField.val(groupData.value);
            groupData.is_parent = true;
            this.depth.push(groupData);
        }
        else {
            // clear depth
            this.clearDepth();

            // clear query input
            this.field.elements.queryInput.value = "";
        }

        // Hide current options
        $(this.field.elements.options.children).not("[data-value='']").hide();

        // set loaders
        $('.loader_no_results').remove();
        $('.loader_small').addClass('is-loading');

        return this.queryByParent(groupData.value.length > 0 ? groupData.value : 0);
    }

    collapse() {
        var currentData = this.depth.pop();

        // Hide current options
        $(this.field.elements.options.children).not("[data-value='']").hide();

        // set loaders
        $('.loader_no_results').remove();
        $('.loader_small').addClass('is-loading');

        return this.queryByParent(currentData && currentData.parent ? currentData.parent : 0);
    }

    clearDepth() {
        this.depth = [];
        this.parentField.val("");
    }

    get currentParent() {
        return this.depth.length > 0 ?
            this.depth[this.depth.length - 1] :
            null;
    }

}